import fuzzy from 'fuzzy';

const getCaseloadFilter = response => {
  const { data } = response;
  const searchable = data.length > 10;
  return {
    key: 'caseloads',
    source: 'caseloads',
    filterName: 'Caseloads',
    searchable,
    defaultSelection: data,
    options: data,
    selector: 'id',
    label: 'displayName',
    search: searchTerm => {
      const results = searchTerm
        ? data.filter(({ name }) => fuzzy.match(searchTerm, name))
        : data;
      return results;
    },
    infiniteScroll: searchable,
    searchOnOpen: searchable,
  };
};

export default getCaseloadFilter;
